// extracted by mini-css-extract-plugin
export default {"switch":"BanksDirectory-module--switch--aljeY"};